export const getWeekStartDate = (input: Date = new Date()): Date => {
  const date = new Date(input);
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day;
  date.setHours(0, 0, 0, 0);
  date.setDate(date.getDate() + diff);
  return date;
};

export const formatWeekStart = (input: Date = new Date()): string => {
  const weekStart = getWeekStartDate(input);
  const year = weekStart.getFullYear();
  const month = `${weekStart.getMonth() + 1}`.padStart(2, "0");
  const day = `${weekStart.getDate()}`.padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const addDays = (input: Date, days: number): Date => {
  const date = new Date(input);
  date.setDate(date.getDate() + days);
  return date;
};

const formatRangePart = (date: Date): string =>
  date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
  });

export const formatWeekRange = (weekStart: Date): string => {
  const start = getWeekStartDate(weekStart);
  const end = addDays(start, 6);
  return `${formatRangePart(start)} - ${formatRangePart(end)}`;
};
